import React from "react";
import { useTheme } from "next-themes"; // Import useTheme hook from next-themes
import logoLight from "../assets/logo.png";
import logoDark from "../assets/logo-dark.png";
import whitepaperPdf from "../assets/whitepaper.pdf";

export default function Footer() {
  const { theme } = useTheme(); // Access the current theme using useTheme hook

  // Determine which logo to use based on the theme
  const logoSrc = theme === "dark" ? logoDark : logoLight;

  const scrollToSection = (id) => {
    const element = document.getElementById(id.substring(1));
    const navbar = document.querySelector(".navbar");
    if (element && navbar) {
      const navbarHeight = navbar.offsetHeight;
      const offsetTop = element.offsetTop - navbarHeight;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };

  const footerNavs = [
    {
      customDiv2: (
        <div>
          <img
            src={logoSrc}
            className="w-[160px] cursor-pointer"
            onClick={() => scrollToSection("#/")}
            alt="Digifolio"
            loading="eager"
          />
        </div>
      ),
      items: [],
    },
    {
      label: "Buy with Confidence",
      items: [
        {
          href: "https://www.bitmart.com/en-GB/trade/DGFL_USDT?type=spot",
          target: "_blank",
          name: "Buy $DGFL",
        },
        {
          href: "whitepaper",
          name: "Whitepaper",
        },
        {
          href: "#Tokenomics",
          name: "Tokenomics",
        },
      ],
    },
    // {
    //   label: "About Us  ",
    //   items: [
    //     {
    //       href: "#Roadmap",
    //       name: "Roadmap",
    //     },
    //     {
    //       href: "#Projects",
    //       name: "Projects",
    //     },
    //     {
    //       href: "#Partners",
    //       name: "Partners",
    //     },
    //   ],
    // },
    {
      label: "Support",
      items: [
        {
          href: "#Faqs",
          name: "FAQs",
        },
      ],
      customDiv: (
        <div className="flex flex-wrap items-center gap-0 mt-8 text-gray-400 md:gap-5 justify-evenly ">
          <a target="_blank" href="https://www.facebook.com/digifoliotoken/">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="49"
                height="49"
                rx="24.5"
                stroke="#333333"
                className="dark:stroke-white "
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M31 17H19C17.897 17 17 17.897 17 19V31C17 32.103 17.897 33 19 33H25V27.5H23V25H25V23C25 22.2044 25.3161 21.4413 25.8787 20.8787C26.4413 20.3161 27.2044 20 28 20H30V22.5H29C28.448 22.5 28 22.448 28 23V25H30.5L29.5 27.5H28V33H31C32.103 33 33 32.103 33 31V19C33 17.897 32.103 17 31 17Z"
                fill="#333333"
                className="dark:fill-white "
              />
            </svg>
          </a>

          <a target="_blank" href="https://www.instagram.com/digifolios/">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="49"
                height="49"
                rx="24.5"
                stroke="#333333"
                className="dark:stroke-white "
              />
              <path
                d="M25 18.4458C27.1205 18.4458 27.4096 18.4458 28.2771 18.4458C29.0482 18.4458 29.4337 18.6386 29.7229 18.7349C30.1084 18.9277 30.3976 19.0241 30.6867 19.3133C30.9759 19.6024 31.1687 19.8916 31.2651 20.2771C31.3614 20.5663 31.4578 20.9518 31.5542 21.7229C31.5542 22.5904 31.5542 22.7831 31.5542 25C31.5542 27.2169 31.5542 27.4096 31.5542 28.2771C31.5542 29.0482 31.3614 29.4337 31.2651 29.7229C31.0723 30.1084 30.9759 30.3976 30.6867 30.6867C30.3976 30.9759 30.1084 31.1687 29.7229 31.2651C29.4337 31.3614 29.0482 31.4578 28.2771 31.5542C27.4096 31.5542 27.2169 31.5542 25 31.5542C22.7831 31.5542 22.5904 31.5542 21.7229 31.5542C20.9518 31.5542 20.5663 31.3614 20.2771 31.2651C19.8916 31.0723 19.6024 30.9759 19.3133 30.6867C19.0241 30.3976 18.8313 30.1084 18.7349 29.7229C18.6386 29.4337 18.5422 29.0482 18.4458 28.2771C18.4458 27.4096 18.4458 27.2169 18.4458 25C18.4458 22.7831 18.4458 22.5904 18.4458 21.7229C18.4458 20.9518 18.6386 20.5663 18.7349 20.2771C18.9277 19.8916 19.0241 19.6024 19.3133 19.3133C19.6024 19.0241 19.8916 18.8313 20.2771 18.7349C20.5663 18.6386 20.9518 18.5422 21.7229 18.4458C22.5904 18.4458 22.8795 18.4458 25 18.4458ZM25 17C22.7831 17 22.5904 17 21.7229 17C20.8554 17 20.2771 17.1928 19.7952 17.3855C19.3133 17.5783 18.8313 17.8675 18.3494 18.3494C17.8675 18.8313 17.6747 19.2169 17.3855 19.7952C17.1928 20.2771 17.0964 20.8554 17 21.7229C17 22.5904 17 22.8795 17 25C17 27.2169 17 27.4096 17 28.2771C17 29.1446 17.1928 29.7229 17.3855 30.2048C17.5783 30.6867 17.8675 31.1687 18.3494 31.6506C18.8313 32.1325 19.2169 32.3253 19.7952 32.6145C20.2771 32.8072 20.8554 32.9036 21.7229 33C22.5904 33 22.8795 33 25 33C27.1205 33 27.4096 33 28.2771 33C29.1446 33 29.7229 32.8072 30.2048 32.6145C30.6867 32.4217 31.1687 32.1325 31.6506 31.6506C32.1325 31.1687 32.3253 30.7831 32.6145 30.2048C32.8072 29.7229 32.9036 29.1446 33 28.2771C33 27.4096 33 27.1205 33 25C33 22.8795 33 22.5904 33 21.7229C33 20.8554 32.8072 20.2771 32.6145 19.7952C32.4217 19.3133 32.1325 18.8313 31.6506 18.3494C31.1687 17.8675 30.7831 17.6747 30.2048 17.3855C29.7229 17.1928 29.1446 17.0964 28.2771 17C27.4096 17 27.2169 17 25 17Z"
                fill="#333333"
                className="dark:fill-white "
              />
              <path
                d="M25 20.8554C22.6867 20.8554 20.8554 22.6867 20.8554 25C20.8554 27.3133 22.6867 29.1446 25 29.1446C27.3133 29.1446 29.1446 27.3133 29.1446 25C29.1446 22.6867 27.3133 20.8554 25 20.8554ZM25 27.6988C23.5542 27.6988 22.3012 26.5422 22.3012 25C22.3012 23.5542 23.4578 22.3012 25 22.3012C26.4458 22.3012 27.6988 23.4578 27.6988 25C27.6988 26.4458 26.4458 27.6988 25 27.6988Z"
                fill="#333333"
                className="dark:fill-white "
              />
              <path
                d="M29.241 21.7229C29.7733 21.7229 30.2048 21.2914 30.2048 20.759C30.2048 20.2267 29.7733 19.7952 29.241 19.7952C28.7086 19.7952 28.2771 20.2267 28.2771 20.759C28.2771 21.2914 28.7086 21.7229 29.241 21.7229Z"
                fill="#333333"
                className="dark:fill-white dark:stroke-slate-100 "
              />
            </svg>
          </a>

          {/* Twitter */}
          <a target="_blank" href="https://twitter.com/digifoliosx">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="49"
                height="49"
                rx="24.5"
                stroke="#333333"
                className="dark:stroke-white "
              />
              <g clip-path="url(#clip0_1_3707)">
                <path
                  d="M30.5387 16H33.7589L26.7238 23.6246L35 34H28.5198L23.4443 27.7074L17.6368 34H14.4147L21.9394 25.8446L14 16H20.6447L25.2325 21.7517L30.5387 16ZM29.4086 32.1723H31.1929L19.6751 17.7317H17.7604L23.5845 24.952L29.4086 32.1723Z"
                  fill="#333333"
                  className="dark:fill-white dark:stroke-slate-100 "
                  q
                />
              </g>
              <defs>
                <clipPath id="clip0_1_3707">
                  <rect
                    width="48"
                    height="48"
                    fill="white"
                    transform="translate(1 1)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a target="_blank" href="https://www.youtube.com/@Digifolios">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              className=""
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="49"
                height="49"
                rx="24.5"
                stroke="#333333"
                className=" dark:stroke-slate-100"
              />
              <path
                d="M35.45 19.4286C35.175 18.4286 34.4875 17.7143 33.525 17.4286C31.875 17 24.8625 17 24.8625 17C24.8625 17 17.9875 17 16.2 17.4286C15.2375 17.7143 14.55 18.4286 14.275 19.4286C14 21.2857 14 25 14 25C14 25 14 28.7143 14.4125 30.5714C14.6875 31.5714 15.375 32.2857 16.3375 32.5714C17.9875 33 25 33 25 33C25 33 31.875 33 33.6625 32.5714C34.625 32.2857 35.3125 31.5714 35.5875 30.5714C36 28.7143 36 25 36 25C36 25 36 21.2857 35.45 19.4286ZM22.8 28.4286V21.5714L28.575 25L22.8 28.4286Z"
                fill="#333333"
                className="dark:fill-white dark:stroke-slate-100 "
              />
            </svg>
          </a>

          <a target="_blank" href="https://t.me/digifoliofficial">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              className=""
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="49"
                height="49"
                rx="24.5"
                stroke="#333333"
                className=" dark:stroke-slate-100"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M38 25C38 32.1797 32.1797 38 25 38C17.8203 38 12 32.1797 12 25C12 17.8203 17.8203 12 25 12C32.1797 12 38 17.8203 38 25ZM25.4659 21.5972C24.2014 22.1231 21.6743 23.2116 17.8846 24.8628C17.2692 25.1075 16.9468 25.3469 16.9174 25.581C16.8678 25.9766 17.3633 26.1324 18.0379 26.3445C18.1297 26.3734 18.2248 26.4033 18.3223 26.435C18.986 26.6508 19.8789 26.9032 20.3431 26.9132C20.7641 26.9223 21.234 26.7487 21.7529 26.3925C25.2938 24.0023 27.1216 22.7941 27.2363 22.7681C27.3173 22.7497 27.4295 22.7266 27.5055 22.7942C27.5815 22.8617 27.574 22.9897 27.566 23.024C27.5169 23.2332 25.5721 25.0413 24.5657 25.9769C24.252 26.2686 24.0294 26.4755 23.9839 26.5228C23.882 26.6286 23.7781 26.7288 23.6783 26.825C23.0617 27.4194 22.5992 27.8652 23.7039 28.5932C24.2348 28.943 24.6596 29.2323 25.0834 29.5209C25.5462 29.8361 26.0078 30.1505 26.6051 30.542C26.7573 30.6417 26.9026 30.7453 27.0441 30.8462C27.5827 31.2302 28.0666 31.5752 28.6645 31.5202C29.0118 31.4882 29.3707 31.1616 29.5529 30.1874C29.9836 27.8851 30.8301 22.8967 31.0257 20.8411C31.0429 20.661 31.0213 20.4305 31.004 20.3293C30.9867 20.2281 30.9505 20.084 30.819 19.9772C30.6632 19.8508 30.4228 19.8242 30.3152 19.8261C29.8263 19.8347 29.0761 20.0956 25.4659 21.5972Z"
                fill="#333333"
                className="dark:fill-white dark:stroke-slate-100"
              />
            </svg>
          </a>

          <a target="_blank" href="https://www.reddit.com/r/Digifolios/">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="49"
                height="49"
                rx="24.5"
                stroke="#333333"
                className=" dark:stroke-slate-100"
              />
              <path
                d="M27.2378 19.1871C27.4286 19.9958 28.1547 20.5982 29.0219 20.5982C30.0342 20.5982 30.8549 19.7775 30.8549 18.7652C30.8549 17.7528 30.0342 16.9321 29.0219 16.9321C28.1367 16.9321 27.3985 17.5595 27.2266 18.3939C25.7442 18.5529 24.5866 19.8102 24.5866 21.3338C24.5866 21.3373 24.5866 21.3399 24.5866 21.3433C22.9744 21.4112 21.5023 21.8701 20.3336 22.5946C19.8996 22.2585 19.3547 22.0583 18.7635 22.0583C17.3447 22.0583 16.1948 23.2081 16.1948 24.627C16.1948 25.6565 16.7998 26.5434 17.6738 26.9533C17.7589 29.9353 21.0082 32.3338 25.0051 32.3338C29.0021 32.3338 32.2557 29.9328 32.3365 26.9481C33.2036 26.5356 33.8034 25.6513 33.8034 24.6278C33.8034 23.209 32.6536 22.0592 31.2347 22.0592C30.6461 22.0592 30.1038 22.2577 29.6707 22.5911C28.4916 21.8615 27.0032 21.4026 25.3747 21.3416C25.3747 21.339 25.3747 21.3373 25.3747 21.3347C25.3747 20.2433 26.1859 19.3375 27.2378 19.1888V19.1871ZM20.2304 26.2572C20.2734 25.3256 20.8922 24.6106 21.6115 24.6106C22.3308 24.6106 22.8808 25.366 22.8378 26.2976C22.7948 27.2292 22.2577 27.5678 21.5376 27.5678C20.8174 27.5678 20.1875 27.1888 20.2304 26.2572ZM28.3997 24.6106C29.1198 24.6106 29.7386 25.3256 29.7807 26.2572C29.8237 27.1888 29.1929 27.5678 28.4736 27.5678C27.7543 27.5678 27.2163 27.23 27.1733 26.2976C27.1304 25.366 27.6795 24.6106 28.3997 24.6106ZM27.5437 28.4125C27.6787 28.4263 27.7646 28.5663 27.7122 28.6918C27.2696 29.7497 26.2246 30.4931 25.0051 30.4931C23.7857 30.4931 22.7415 29.7497 22.2981 28.6918C22.2457 28.5663 22.3316 28.4263 22.4665 28.4125C23.2572 28.3326 24.1122 28.2888 25.0051 28.2888C25.898 28.2888 26.7522 28.3326 27.5437 28.4125Z"
                fill="#333333"
                className="dark:fill-white dark:stroke-slate-100 "
              />
            </svg>
          </a>

          <a target="_blank" href="https://discord.com/invite/sKWPvdmjSa">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="49"
                height="49"
                rx="24.5"
                stroke="#333333"
                className=" dark:stroke-slate-100"
              />
              <path
                d="M31.9308 18.4629C30.6561 17.878 29.2892 17.4471 27.8599 17.2003C27.8339 17.1955 27.8079 17.2074 27.7945 17.2312C27.6187 17.5439 27.4239 17.9518 27.2876 18.2724C25.7503 18.0423 24.221 18.0423 22.7153 18.2724C22.5789 17.9447 22.3771 17.5439 22.2005 17.2312C22.1871 17.2082 22.1611 17.1963 22.135 17.2003C20.7066 17.4463 19.3396 17.8772 18.0641 18.4629C18.0531 18.4677 18.0436 18.4756 18.0373 18.4859C15.4445 22.3595 14.7342 26.138 15.0827 29.8695C15.0842 29.8878 15.0945 29.9053 15.1087 29.9164C16.8193 31.1726 18.4764 31.9353 20.1027 32.4408C20.1288 32.4488 20.1563 32.4393 20.1729 32.4178C20.5576 31.8925 20.9005 31.3385 21.1946 30.756C21.2119 30.7219 21.1954 30.6814 21.1599 30.6679C20.6159 30.4616 20.098 30.21 19.5998 29.9243C19.5604 29.9013 19.5572 29.8449 19.5935 29.8179C19.6983 29.7394 19.8032 29.6576 19.9033 29.5751C19.9214 29.56 19.9466 29.5568 19.9679 29.5664C23.2411 31.0608 26.7846 31.0608 30.0191 29.5664C30.0404 29.5561 30.0657 29.5592 30.0846 29.5743C30.1847 29.6568 30.2896 29.7394 30.3952 29.8179C30.4314 29.8449 30.4291 29.9013 30.3897 29.9243C29.8914 30.2155 29.3735 30.4616 28.8288 30.6671C28.7933 30.6806 28.7775 30.7219 28.7949 30.756C29.0952 31.3377 29.4381 31.8917 29.8157 32.417C29.8315 32.4393 29.8599 32.4488 29.8859 32.4408C31.5201 31.9353 33.1772 31.1726 34.8879 29.9164C34.9028 29.9053 34.9123 29.8886 34.9139 29.8703C35.3309 25.5562 34.2154 21.8088 31.9568 18.4867C31.9513 18.4756 31.9419 18.4677 31.9308 18.4629ZM21.6834 27.5974C20.6979 27.5974 19.8859 26.6927 19.8859 25.5816C19.8859 24.4706 20.6822 23.5659 21.6834 23.5659C22.6924 23.5659 23.4965 24.4785 23.4807 25.5816C23.4807 26.6927 22.6845 27.5974 21.6834 27.5974ZM28.329 27.5974C27.3435 27.5974 26.5316 26.6927 26.5316 25.5816C26.5316 24.4706 27.3278 23.5659 28.329 23.5659C29.338 23.5659 30.1421 24.4785 30.1264 25.5816C30.1264 26.6927 29.338 27.5974 28.329 27.5974Z"
                fill="#333333"
                className="dark:fill-white dark:stroke-slate-100 "
              />
            </svg>
          </a>
        </div>
      ),
    },
  ];

  return (
    <footer className="pt-10 border-t border-[#686868]">
      <div className="max-w-screen-xl px-4 mx-auto md:px-8">
        <div className="justify-between flex-1 space-y-6 sm:flex md:space-y-0">
          {footerNavs.map((item, idx) => (
            <ul className="space-y-4 text-gray-600" key={idx}>
              <h4 className="text-heading dark:text-gray-200 text2 lg:text-[18px]  md:text[10px] font-semibold ">
                {item.label}
                {item.customDiv2 && <li key="custom">{item.customDiv2}</li>}
              </h4>

              {item.items.map((el, idx) => (
                <li key={idx}>
                  <a
                    onClick={() => {
                      if (el.href == "https://www.bitmart.com/en-GB/trade/DGFL_USDT?type=spot") {
                        window.open(el.href, "_blank");
                      } else if (el.href == "whitepaper") {
                        const link = document.createElement("a");
                        link.href = whitepaperPdf; // Path to your PDF file
                        link.setAttribute("download", "whitepaper.pdf"); // Name of the downloaded file
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      } else {
                        scrollToSection(el.href);
                      }
                    }}
                    className="duration-150 cursor-pointer hover:text-green-700 dark:hover:text-green-600 text-para dark:text-gray-200"
                  >
                    {el.name}
                  </a>
                </li>
              ))}
              {item.customDiv && <li key="custom">{item.customDiv}</li>}
            </ul>
          ))}
        </div>
        <div className="items-center justify-center py-6 mt-6 border-[#686868] border-t sm:flex">
          <p>
            © 2024 - Copyright Digifolio - Developed by{" "}
            <a
              className="hover:text-green-700 dark:hover:text-green-600 duration-250"
              href="https://blockliz.com"
              target="_blank"
            >
              BLOCKLIZ
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
